export { default } from './checkbox'
export type { TProps as TCheckboxProps } from './checkbox'
